<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="px-5 pb-2" style="border: 1px solid;">
        <v-flex xs12 class="noprint">
          <h3 class="text-center">Patient Lab Test</h3>
          <v-btn small text :href="'/clients/' + client.id + '/visits/' + visit.id" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id)" title="Back" v-if="client && visit">
            <v-icon left>mdi-menu-left</v-icon>Back
          </v-btn>
          <v-btn small text :href="'/patient_tests'" @click.stop.prevent="goTo('/patient_tests')" title="Back" v-else>
            <v-icon left>mdi-menu-left</v-icon>Back
          </v-btn>
          <v-btn small icon title="Print" @click="printTest" class="pull-right">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
          <v-btn small icon title="Edit" @click="edit = !edit" class="pull-right hidden">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <invoices-button :href="invoiceLink" class="pull-right"></invoices-button>
        </v-flex>
        <v-flex :xs12="$breakpoint.xsOnly" :xs6="!$breakpoint.xsOnly" :class="!$breakpoint.xsOnly ? 'pr-10' : ''">
          <my-details :detail="['Patient Name', client.name]"></my-details>
          <my-details :detail="['', client.email]"></my-details>
          <my-details :detail="['', client.phone]"></my-details>
        </v-flex>
        <v-flex :xs12="$breakpoint.xsOnly" :xs6="!$breakpoint.xsOnly">
          <my-details :detail="['Tracking Number', '#' + test.id]"></my-details>
          <my-details :detail="['Total Cost', test.currency + ' '  + test.cost ? test.cost.format(2) : '']"></my-details>
        </v-flex>
        <v-flex xs12>
          <v-card flat class="px-0">
            <v-card-text class="px-0">
              <lab-entries :patient_test="test" :patient_test_entries="patient_test_entries"></lab-entries>
              <div class="noprint text-center" v-show="test.invoices_count < 1">
                <v-btn small outlined text @click="AddEntry = true">
                  <v-icon left>mdi-flask</v-icon>
                  Add Test
                </v-btn>
              </div>
            </v-card-text>
            <v-card-actions class="py-0 print-only">
              <v-spacer></v-spacer>
              <span>&copy; {{ $title }}</span>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 class="noprint">
          <a class="pull-right text-muted red--text mt-10" v-show="test.longitude || test.latitude" target="_blank" rel="noopener nofollow noreferrer" title="Sample Collection Point" :href="test.place">Sample Collection Point</a>
        </v-flex>
      </v-layout>
      <modal-dialog :open="edit" @close="edit = false">
        <template #title>
          Edit Lab Test
          <v-btn small text outlined @click="goTo(route('patient_tests_requested.patient_test.edit', [test.id]))" v-if="route('patient_tests_requested.patient_test.show', [test.id])" color="white">
            <v-icon left>mdi-flask</v-icon>
            Edit Lab Details
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <form @submit.prevent="updateTest(test)">
              <v-textarea label="Results" auto-grow v-model="test.results" rows="3"></v-textarea>
              <v-textarea label="Comment" auto-grow v-model="test.comment" rows="2"></v-textarea>
              <v-btn type="submit" class="primary pull-right">Save</v-btn><br>
            </form>
          </v-card-text>
        </v-card>
      </modal-dialog>
      <mk-dialog v-model="AddEntry">
        <template #title>Add Lab test</template>
        <add-lab-entry :client="client" :patient_test="test" :laboratories="laboratories" @loadTest="getTests" @saved="AddEntry = false; getTests()" :errors="errors"></add-lab-entry>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const AddLabEntry = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/create-entry')
  const LabEntries = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/entries')

  export default {
    name: 'PatientLabTest',
    layout,
    props: [
      'client', 'test', 'visit', 'edit_link', 'laboratories', 'errors'
    ],
    components: {
      MkDialog,
      MyDetails,
      LabEntries,
      ModalDialog,
      AddLabEntry,
    },
    metaInfo () {
      return {
        title: 'Lab Test',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        edit: false,
        AddEntry: false,
      }
    },
    methods: {
      updateTest (test) {
        this.$inertia.put(this.edit_link, test, {
          preserveScroll: true,
          onSuccess: () => {
            this.edit = false
            // this.$inertia.get(route('clients.visits.show', { client: this.client.id, visit: this.visit.id }))
          }
        })
      },
      printTest () {
        window.print()
      },
      viewInvoices () {
        if (this.client && this.visit) {
          this.$inertia.visit(route('clients.visits.lab.invoices.index', [this.client.id, this.visit.id, this.test.id]))
        } else {
          this.$inertia.visit(route('patient_tests_requested.patient_test.invoices.index', [this.test.id]))
        }
      },
      getTests () {
        this.$inertia.reload({ only: ['laboratories'] })
      }
    },
    computed: {
      patient_test_entries () {
        return this.test.patient_test_entries
      },
      invoiceLink () {
        if (this.client && this.visit) {
          return route('clients.visits.lab.invoices.index', [this.client.id, this.visit.id, this.test.id])
        } else {
          return route('patient_tests_requested.patient_test.invoices.index', [this.test.id])
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getTests()
      })
    }
  }
</script>

<style lang="scss" scoped>
  @media print {
    .container {
      background-color: rgba(255, 255, 255, 0.911) !important;
    }
  }
  .left-borderless {
    border: 1px solid;
    border-left: none;
  }
</style>
